import React from 'react'
import cn from "classnames";
import { Divider } from "antd";
import { useNavigate } from 'react-router-dom';

import styles from "./CreateMultipleTotes.module.sass"
import Modal from '../../../components/Modal';
import { BARCODE_LOCAL_STORAGE_KEY } from '../../../constants';

const PrintToteCodes = ({ isModalVisible, handleModalClose, handleSuccess, newCreatedTotesCode }) => {
    const navigate = useNavigate();

    const setBarcodesInLocalStorage = (barcodes) => {
        localStorage.setItem(BARCODE_LOCAL_STORAGE_KEY, JSON.stringify(barcodes));
    }

    const handleOnPrintClick = async () => {
        setBarcodesInLocalStorage(newCreatedTotesCode);
        navigate('/barcodeprint');
        handleSuccess();
    }

    return (
        <>
            <Modal visible={isModalVisible} onClose={handleModalClose}>
                <div className={styles.details}>
                    <div className={cn("title-red", styles.title)}>
                        Confirm Print
                    </div>
                    <div className={styles.roww}>
                        <div className={styles.coll}>
                            <Divider />
                            <p className="text-[#6F767E]">
                                Would you like to print the newly created totes?
                            </p>
                            <div className={cn(styles.btns)}>
                                <button
                                    type="button"
                                    className={cn("button-stroke pl-5 pr-5", styles.button)}
                                    onClick={handleModalClose}
                                >
                                    I’ll do it later
                                </button>
                                <button
                                    type="button"
                                    className={cn("button", styles.button)}
                                    onClick={handleOnPrintClick}
                                >
                                    Yes, Print Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default PrintToteCodes